import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { ElMessage } from 'element-plus';
import alertAbnormalReasonTw from '@/assets/img/alertAbnormalReason-zhtw.png';
import alertAbnormalReasonEn from '@/assets/img/alertAbnormalReason-en.png';
import alertAbnormalReasonCn from '@/assets/img/alertAbnormalReason-cn.png';
import controlItemHandleInputTw from '@/assets/img/controlItemHandleInput-zhtw.png';
import controlItemHandleInputEn from '@/assets/img/controlItemHandleInput-en.png';
import controlItemHandleInputCn from '@/assets/img/controlItemHandleInput-cn.png';
import selectInspectTw from '@/assets/img/selectInspect-zhtw.png';
import selectInspectEn from '@/assets/img/selectInspect-en.png';
import selectInspectCn from '@/assets/img/selectInspect-cn.png';
// import goldenSampleExcel from '@/assets/img/goldenSampleExcel.png';
import goldenSampleExcelTw from '@/assets/img/goldenSampleExcel-zhtw.png';
import goldenSampleExcelEn from '@/assets/img/goldenSampleExcel-en.png';
import goldenSampleExcelCn from '@/assets/img/goldenSampleExcel-cn.png';

/**
 * 過濾異常原因管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpAbnormalReasonManagement(i18n, store) {
  let imgSource = null;

  let message = '';
  let elementName = '.searchitem.btn';
  if (store.state.settingManagement.activeName === 'B_1_1') {
    elementName = '.searchitem.btn';
    message = i18n.$t('SettingManagement').FilterAbnormalReasonExplain;
  } else {
    elementName = '#tab-B_1_1';
    message = i18n.$t('SettingManagement').clickAbnormalReasonManagementFirst;
  }

  switch (store.state.lang) {
    case 'zhtw':
      imgSource = alertAbnormalReasonTw;
      break;

    case 'en':
      imgSource = alertAbnormalReasonEn;
      break;

    case 'cn':
      imgSource = alertAbnormalReasonCn;
      break;

    default:
      imgSource = alertAbnormalReasonTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: elementName,
        popover: {
          title: i18n.$t('SettingManagement').FilterAbnormalReason,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_1') {
              console.log('確認有按異常原因管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.b1-button-add',
        popover: {
          title: i18n.$t('SettingManagement').CreateAbnormalReason,
          description: i18n.$t('SettingManagement').CreateAbnormalReasonExplain,
          onNextClick: () => {
            if (store.state.settingManagement.abnormalReasonAddFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveNext();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#inputName',
        popover: {
          title: i18n.$t('SettingManagement').CreateAbnormalReason,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput}"\\/[]!@#$%^&*()+</p>`,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').CreateAbnormalReason,
          description: `
          <table>
            <tr>
              <td>
                <img src='${imgSource}' width="600"/>
              </td>
              <td>
                <p>${i18n.$t('SettingManagement').CreateAbnormalReasonExplainMore}</p>
              </td>
            </tr>
          </table>
          `,
          popoverClass: 'classImgExplain',
          side: 'top',
          align: 'center',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫異常原因管理-編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEditAbnormalReasonManagement(i18n, store) {
  const tempList = store.state.settingManagement.abnormalReasonList;

  let message = '';
  let elementName = '.editBtn';

  if (store.state.settingManagement.activeName === 'B_1_1') {
    elementName = '.editBtn';
    if (tempList.length > 0) {
      message = i18n.$t('SettingManagement').EditAbnormalReasonExplain;
    } else {
      message = i18n.$t('DriverTourHelp').createDataFirst;
    }
  } else {
    elementName = '#tab-B_1_1';
    message = i18n.$t('SettingManagement').clickAbnormalReasonManagementFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: elementName,
        popover: {
          title: i18n.$t('SettingManagement').EditAbnormalReason,
          description: message,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫異常原因管理-刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDeleteAbnormalReasonManagement(i18n, store) {
  const tempList = store.state.settingManagement.abnormalReasonList;

  let message = '';
  let elementName = '.deleteBtn';

  if (store.state.settingManagement.activeName === 'B_1_1') {
    elementName = '.deleteBtn';
    if (tempList.length > 0) {
      message = i18n.$t('SettingManagement').DeleteAbnormalReasonExplain;
    } else {
      message = i18n.$t('DriverTourHelp').createDataFirst;
    }
  } else {
    elementName = '#tab-B_1_1';
    message = i18n.$t('SettingManagement').clickAbnormalReasonManagementFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: elementName,
        popover: {
          title: i18n.$t('SettingManagement').DeleteAbnormalReason,
          description: message,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫缺陷管理
 * @param {*} i18n
 */
export function callHelpDefectDefinition(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_2') {
    message = i18n.$t('SettingManagement').DefectDefinitionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickDefectDefinitionFirst;
  }

  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = controlItemHandleInputTw;
      break;

    case 'en':
      imgSource = controlItemHandleInputEn;
      break;

    case 'cn':
      imgSource = controlItemHandleInputCn;
      break;

    default:
      imgSource = controlItemHandleInputTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_2',
        popover: {
          title: i18n.$t('SettingManagement').DefectDefinition,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_2') {
              console.log('確認有按缺陷管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.searchitem.btn.defectDefine',
        popover: {
          title: i18n.$t('SettingManagement').FilterDefectDefinition,
          description: i18n.$t('SettingManagement').FilterDefectDefinitionExplain,
        },
      },
      {
        element: '.b1-button-add.defectDefine',
        popover: {
          title: i18n.$t('SettingManagement').AddDefectDefinition,
          description: i18n.$t('SettingManagement').AddDefectDefinitionExplain,
          onNextClick: () => {
            if (store.state.settingManagement.defectDefineFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },
      {
        element: '#inputName',
        popover: {
          title: i18n.$t('SettingManagement').AddDefectDefinition,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput}"\\/[]!@#$%^&*()+</p>`,
        },
      },
      {
        element: '#controlItem',
        popover: {
          title: i18n.$t('SettingManagement').ControlItem,
          description: i18n.$t('SettingManagement').ControlItemExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').ControlItem,
          description: `
          ${i18n.$t('SettingManagement').afterAddDefect}
          <img src='${imgSource}' width="850"></img>
          `,
          popoverClass: 'controlItemClass',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫編輯缺陷管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEditDefectDefinition(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_2') {
    message = i18n.$t('SettingManagement').DefectDefinitionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickDefectDefinitionFirst;
  }

  const tempList = store.state.settingManagement.abnormalReasonList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').EditDefectDefinitionExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_2',
        popover: {
          title: i18n.$t('SettingManagement').DefectDefinition,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_2') {
              console.log('確認有按缺陷管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }

              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.defectDefine',
        popover: {
          title: i18n.$t('SettingManagement').EditDefectDefinition,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除缺陷管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDeleteDefectDefinition(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_2') {
    message = i18n.$t('SettingManagement').DefectDefinitionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickDefectDefinitionFirst;
  }

  const tempList = store.state.settingManagement.abnormalReasonList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').DeleteDefectDefinitionExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_2',
        popover: {
          title: i18n.$t('SettingManagement').DefectDefinition,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_2') {
              console.log('確認有按缺陷管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.defectDefine',
        popover: {
          title: i18n.$t('SettingManagement').DeleteDefectDefinition,
          description: deleteMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫檢驗判定管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpInspection(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_3') {
    message = i18n.$t('SettingManagement').InspectionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickInspectionFirst;
  }

  let imgSource = null;
  switch (store.state.lang) {
    case 'zhtw':
      imgSource = selectInspectTw;
      break;

    case 'en':
      imgSource = selectInspectEn;
      break;

    case 'cn':
      imgSource = selectInspectCn;
      break;

    default:
      imgSource = selectInspectTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_3',
        popover: {
          title: i18n.$t('SettingManagement').Inspection,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_3') {
              console.log('確認有按檢驗判定管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }

              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchitem.btn.inspecJudgDefine',
        popover: {
          title: i18n.$t('SettingManagement').FilterInspection,
          description: i18n.$t('SettingManagement').FilterInspectionExplain,
        },
      },

      {
        element: '.b1-button-add.inspecJudgDefine',
        popover: {
          title: i18n.$t('SettingManagement').AddInspection,
          description: i18n.$t('SettingManagement').AddInspectionExplain,
          onNextClick: () => {
            if (store.state.settingManagement.inspecJudgDefineFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#inputName',
        popover: {
          title: i18n.$t('SettingManagement').AddInspection,
          description: `
          <p>${i18n.$t('DriverTourHelp').ColumnIsRequire}</p>
          <p>${i18n.$t('DriverTourHelp').notInput}"\\/[]!@#$%^&*()+</p>`,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').afterAddInspection,
          description: `
          ${i18n.$t('SettingManagement').afterAddInspectionExplain}
           <img src='${imgSource}' width="850"></img>
          `,
          popoverClass: 'inspectionClass',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫編輯檢驗判定管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpEditInspection(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_3') {
    message = i18n.$t('SettingManagement').InspectionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickInspectionFirst;
  }

  const tempList = store.state.settingManagement.abnormalReasonList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').EditInspectionExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_3',
        popover: {
          title: i18n.$t('SettingManagement').Inspection,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_3') {
              console.log('確認有按檢驗判定管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.inspecJudgDefine',
        popover: {
          title: i18n.$t('SettingManagement').EditInspection,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫刪除檢驗判定管理
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpDeleteInspection(i18n, store) {
  let message = '';
  if (store.state.settingManagement.activeName === 'B_1_3') {
    message = i18n.$t('SettingManagement').InspectionDescription;
  } else {
    message = i18n.$t('SettingManagement').clickInspectionFirst;
  }

  const tempList = store.state.settingManagement.abnormalReasonList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').DeleteInspectionExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-B_1_3',
        popover: {
          title: i18n.$t('SettingManagement').Inspection,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.activeName === 'B_1_3') {
              console.log('確認有按檢驗判定管理的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.inspecJudgDefine',
        popover: {
          title: i18n.$t('SettingManagement').DeleteInspection,
          description: deleteMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫層別設定-產品 篩選、新增
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProduct(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '0') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.productDescription;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProductFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-0',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.product,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '0') {
              console.log('確認有按層別設定產品的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.searchbutton.model',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.filterProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.filterProductExplain,
        },
      },
      {
        element: '.addBtn.model',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.addProductExplain,
          onNextClick: () => {
            if (store.state.settingManagement.levelProductFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.model_code_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.model_code',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.productCodeExplain,
        },
      },
      {
        element: '.model_name_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.model_name',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.productNameExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: `
          <p>${i18n.$t('SettingManagement').LevelTypeDefinition.productParamExplain}</p>
          <p>${i18n.$t('SettingManagement').LevelTypeDefinition.productMachineExplain}</p>`,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.explain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫層別設定-產品 編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProductEdit(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '0') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelProduct;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProductFirst;
  }

  const tempList = store.state.settingManagement.productList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').LevelTypeDefinition.editProductExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-0',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.product,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '0') {
              console.log('確認有按層別設定產品的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.model',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.editProduct,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-產品 刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProductDelete(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '0') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelProduct;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProductFirst;
  }

  const tempList = store.state.settingManagement.productList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').LevelTypeDefinition.deleteProductExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-0',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.product,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '0') {
              console.log('確認有按層別設定產品的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.model',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProduct,
          description: deleteMessage,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProduct,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.productExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定 機台
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelMachine(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '1') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.machineDescription;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelMachineFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-1',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.machine,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '1') {
              console.log('確認有按層別設定機台的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchbutton.machine',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.filterMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.filterMachineExplain,
        },
      },

      {
        element: '.addBtn.machine',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.addMachineExplain,
          onNextClick: () => {
            if (store.state.settingManagement.levelMachineFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.machine_code_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.machine_code',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.machineCodeExplain,
        },
      },
      {
        element: '.machine_name_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.machine_name',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.machineNameExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: `
          <p>${i18n.$t('SettingManagement').LevelTypeDefinition.machineParamExplain}</p>
          <p>${i18n.$t('SettingManagement').LevelTypeDefinition.machineMachineExplain}</p>`,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.explain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫層別設定-機台 編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelMachineEdit(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '1') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelMachine;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelMachineFirst;
  }

  const tempList = store.state.settingManagement.machineList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').LevelTypeDefinition.editMachineExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-1',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.machine,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '1') {
              console.log('確認有按層別設定機台的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.machine',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.editMachine,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-機台 刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelMachineDelete(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '1') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelMachine;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelMachineFirst;
  }

  const tempList = store.state.settingManagement.machineList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').LevelTypeDefinition.deleteMachineExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-1',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.machine,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '1') {
              console.log('確認有按層別設定機台的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.machine',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteMachine,
          description: deleteMessage,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteMachine,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.machineExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-製程
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProcess(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '2') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.groupDescription;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProcessFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-2',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.group,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '2') {
              console.log('確認有按層別設定製程的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchbutton.group',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.filterProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.filterProcessExplain,
        },
      },

      {
        element: '.addBtn.group',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.addProcessExplain,
          onNextClick: () => {
            if (store.state.settingManagement.levelGroupFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.group_code_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.group_code',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ProcessCodeExplain,
        },
      },
      {
        element: '.group_name_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.group_name',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ProcessNameExplain,
        },
      },
      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ProcessParamExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫層別設定-製程 編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProcessEdit(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '2') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelProcess;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProcessFirst;
  }

  const tempList = store.state.settingManagement.processList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').LevelTypeDefinition.editProcessExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-2',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.group,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '2') {
              console.log('確認有按層別設定製程的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.group',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.editProcess,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-製程 刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelProcessDelete(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '2') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelProcess;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelProcessFirst;
  }

  const tempList = store.state.settingManagement.processList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').LevelTypeDefinition.deleteProcessExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-2',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.group,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '2') {
              console.log('確認有按層別設定製程的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.group',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProcess,
          description: deleteMessage,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteProcess,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ProcessExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-參數
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelParams(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '3') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.parametersDescription;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelParamsFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-3',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.parameters,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '3') {
              console.log('確認有按層別設定參數的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },

      {
        element: '.searchbutton.params',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.filterParams,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.filterParamsExplain,
        },
      },

      {
        element: '.addBtn.params',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addParams,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.addParamsExplain,
          onNextClick: () => {
            if (store.state.settingManagement.levelParamsFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(2);
              }, 3000);
            }
          },
        },
      },
      {
        element: '.params_code_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addParams,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.params_code',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addParams,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ParamsCodeExplain,
        },
      },
      {
        element: '.params_name_require',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addParams,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '.params_name',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.addParams,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ParamsNameExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}

/**
 * 呼叫層別設定-參數 編輯
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelParamsEdit(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '3') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelParams;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelParamsFirst;
  }

  const tempList = store.state.settingManagement.paramsList;

  let editMessage = '';
  if (tempList.length > 0) {
    editMessage = i18n.$t('SettingManagement').LevelTypeDefinition.editParamsExplain;
  } else {
    editMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-3',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.parameters,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '3') {
              console.log('確認有按層別設定參數的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.editBtn.params',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.editParams,
          description: editMessage,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫層別設定-參數 刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLevelParamsDelete(i18n, store) {
  let message = '';
  if (store.state.settingManagement.levelActiveTabValue === '3') {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.confirmClickLevelParams;
  } else {
    message = i18n.$t('SettingManagement').LevelTypeDefinition.clickSetLevelParamsFirst;
  }

  const tempList = store.state.settingManagement.paramsList;

  let deleteMessage = '';
  if (tempList.length > 0) {
    deleteMessage = i18n.$t('SettingManagement').LevelTypeDefinition.deleteParamsExplain;
  } else {
    deleteMessage = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#tab-3',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.parameters,
          description: message,
          onPopoverRender: () => {
            if (store.state.settingManagement.levelActiveTabValue === '3') {
              console.log('確認有按層別設定參數的Tab');
            } else {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
              setTimeout(() => {
                driverObj.destroy();
              }, 3000);
            }
          },
        },
      },
      {
        element: '.deleteBtn.params',
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteParams,
          description: deleteMessage,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').LevelTypeDefinition.deleteParams,
          description: i18n.$t('SettingManagement').LevelTypeDefinition.ParamsExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫動態欄位設定
 * @param {*} i18n
 */
export function callHelpDynamicFieldSettings(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.searchitem.btn',
        popover: {
          title: i18n.$t('SettingManagement').DynamicFieldSettings.filter,
          description: i18n.$t('SettingManagement').DynamicFieldSettings.filterExplain,
        },
      },

      {
        element: '#btnEdit',
        popover: {
          title: i18n.$t('SettingManagement').DynamicFieldSettings.edit,
          description: i18n.$t('SettingManagement').DynamicFieldSettings.editExplain,
          onNextClick: () => {
            if (store.state.settingManagement.dynamicFieldSettingsEditVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickEditButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#fieldName',
        popover: {
          title: i18n.$t('SettingManagement').DynamicFieldSettings.edit,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').DynamicFieldSettings.edit,
          description: `
          <p>${i18n.$t('SettingManagement').DynamicFieldSettings.explain}</p>
          <p>${i18n.$t('SettingManagement').DynamicFieldSettings.notNumber}</p>`,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制圖規則 包含篩選、新增
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpControlChartRules(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.searchitem.btn',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.filter,
          description: i18n.$t('SettingManagement').ControlChartRules.filterExplain,
        },
      },

      {
        element: '.btnAdd',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.create,
          description: i18n.$t('SettingManagement').ControlChartRules.createExplain,
          onNextClick: () => {
            if (store.state.settingManagement.controlChartRulesCreateVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.ruleName',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '.ruleName',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.create,
          description: i18n.$t('SettingManagement').ControlChartRules.explainRuleName,
        },
      },

      {
        element: '#ruleList',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.create,
          description: i18n.$t('SettingManagement').ControlChartRules.explainRule,
        },
      },

      {
        // 參閱管制圖設定
        popover: {
          title: i18n.$t('ControlItem').Setting.controlChartSetting,
          description: i18n.$t('SettingManagement').ControlChartRules.readControlChartSetting,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫管制圖規則 編輯、刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpControlChartRulesEditAndDelete(i18n, store) {
  const tempList = store.state.settingManagement.controlChartRulesList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('SettingManagement').ControlChartRules.editExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editBtn',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.edit,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.delete,
          description: i18n.$t('SettingManagement').ControlChartRules.deleteExplain,
        },
      },

      {
        popover: {
          title: i18n.$t('SettingManagement').ControlChartRules.delete,
          description: i18n.$t('SettingManagement').ControlChartRules.deleteExplainMore,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫標準樣本設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpGoldenSampleSetting(i18n, store) {
  let imageSource = null;

  switch (store.state.lang) {
    case 'zhtw':
      imageSource = goldenSampleExcelTw;
      break;

    case 'en':
      imageSource = goldenSampleExcelEn;
      break;

    case 'cn':
      imageSource = goldenSampleExcelCn;
      break;

    default:
      imageSource = goldenSampleExcelTw;
      break;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.searchitem.btn',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.filter,
          description: i18n.$t('SettingManagement').GoldenSampleSetting.filterExplain,
        },
      },

      {
        element: '#btnAdd',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.create,
          description: i18n.$t('SettingManagement').GoldenSampleSetting.createExplain,
          onNextClick: () => {
            if (store.state.settingManagement.goldenSampleSettingCreateVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.goldenSampleName',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '.sampleNum',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.create,
          description: i18n.$t('SettingManagement').GoldenSampleSetting.sampleCountExplain,
        },
      },

      {
        element: '#previewBtn',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.create,
          description: i18n.$t('SettingManagement').GoldenSampleSetting.clickExplain,
        },
      },

      {
        element: '.upload-wrap',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.create,
          description: `
          <table>
            <tr>
              <td>
                <img src="${imageSource}" width="500"/>
              </td>
              <td>
                <p>${i18n.$t('SettingManagement').GoldenSampleSetting.fileUploadExplain}</p>
                <p style="color:red">
                ${i18n.$t('SettingManagement').GoldenSampleSetting.fileUploadNotice}
                </p>
              </td>
            </tr>
          </table>
        `,
          popoverClass: 'excelImgClass',
          side: 'top',
          align: 'center',
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫標準樣本設定 編輯、刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpGoldenSampleSettingEditAndDelete(i18n, store) {
  const tempList = store.state.settingManagement.standardSampleSettingList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('SettingManagement').GoldenSampleSetting.editExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editBtn',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.edit,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('SettingManagement').GoldenSampleSetting.delete,
          description: i18n.$t('SettingManagement').GoldenSampleSetting.deleteExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫制程能力等級
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpProcessAnalysisRanks(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.searchitem.btn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.filter,
          description: i18n.$t('SettingManagement').ProcessAnalysisRanks.filterExplain,
        },
      },

      {
        element: '#btnAdd',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRanks.createExplain,
          onNextClick: () => {
            if (store.state.settingManagement.processAnalysisRanksCreateVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '#inputName',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '#A_0',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRanks.createExplainMore,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫製程能力等級編輯與刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpProcessAnalysisRanksEditAndDelete(i18n, store) {
  const tempList = store.state.settingManagement.processAnalysisRanksList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('SettingManagement').ProcessAnalysisRanks.editExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.edit,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRanks.delete,
          description: i18n.$t('SettingManagement').ProcessAnalysisRanks.deleteExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫Indicator
 * @param {*} i18n
 */
export function callHelpIndicator(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.el-tabs__header.is-top',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.name,
          description: i18n.$t('SettingManagement').Indicator.chartTabs,
        },
      },

      {
        element: '.d-flex',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.name,
          description: i18n.$t('SettingManagement').Indicator.defaultTarget,
        },
      },

      {
        element: '.el-table__body-wrapper',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.name,
          description: i18n.$t('SettingManagement').Indicator.dragExplain,
        },
      },

      {
        element: '.resetBtn',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.rollbackDefault,
          description: i18n.$t('SettingManagement').Indicator.rollbackDefaultExplain,
        },
      },

      {
        element: '.confirmBtn',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.confirm,
          description: i18n.$t('SettingManagement').Indicator.confirmExplain,
        },
      },

      {
        element: '.confirmBtn',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.confirm,
          description: i18n.$t('SettingManagement').Indicator.finalExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫 Indicator QA
 * @param {*} i18n
 */
export function callHelpIndicatorQA(i18n) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#A_0',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.qa,
          description: i18n.$t('SettingManagement').Indicator.qaExplain,
        },
      },

      {
        element: '#A_2',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.qa,
          description: i18n.$t('SettingManagement').Indicator.SelectControlItemInformation,
        },
      },

      {
        element: '.el-tree.filter-tree.mt-2',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.qa,
          description: i18n.$t('SettingManagement').Indicator.qaExplainSelectControlItem,
        },
      },

      {
        element: '.btnView',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.qa,
          description: i18n.$t('SettingManagement').Indicator.view,
        },
      },

      {
        element: '.IndicatorsRegion',
        popover: {
          title: i18n.$t('SettingManagement').Indicator.qa,
          description: i18n.$t('SettingManagement').Indicator.clickIndicator,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫排程設定
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpScheduleSettings(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.searchitem.btn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.filter,
          description: i18n.$t('SettingManagement').ScheduleSettings.filterExplain,
        },
      },

      {
        element: '#btnAdd',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.create,
          description: i18n.$t('SettingManagement').ScheduleSettings.createExplain,
          onNextClick: () => {
            if (store.state.settingManagement.scheduleSettingsFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveTo(1);
              }, 3000);
            }
          },
        },
      },

      {
        element: '.mustLeft',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '.mustRight',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },

      {
        element: '#reportDate',
        popover: {
          title: i18n.$t('Label').report_date,
          description: i18n.$t('SettingManagement').ScheduleSettings.reportDate,
        },
      },

      {
        element: '#reportType',
        popover: {
          title: i18n.$t('Label').report_type,
          description: i18n.$t('SettingManagement').ScheduleSettings.reportType,
        },
      },

      {
        element: '#dynamicField',
        popover: {
          title: i18n.$t('Button').dynamic_field,
          description: i18n.$t('SettingManagement').ScheduleSettings.dynamicField,
        },
      },

      {
        element: '#hiddenFunction',
        popover: {
          title: i18n.$t('TableHeader').noise_point,
          description: `
          <p>${i18n.$t('SettingManagement').ScheduleSettings.hiddenFunction}</p>
          <p>${i18n.$t('SettingManagement').ScheduleSettings.hiddenFunctionNo}</p>`,
        },
      },

      {
        element: '#editFunction',
        popover: {
          title: i18n.$t('TableHeader').modify_data,
          description: i18n.$t('SettingManagement').ScheduleSettings.editFunction,
        },
      },

      {
        element: '#email',
        popover: {
          title: i18n.$t('Label')['a-email'],
          description: i18n.$t('SettingManagement').ScheduleSettings.eMail,
        },
      },

      {
        element: '#wechat',
        popover: {
          title: i18n.$t('Label')['a-wechat'],
          description: i18n.$t('SettingManagement').ScheduleSettings.weChat,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫排程設定-執行、編輯、使用者、群組、通知對象、刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpScheduleSettingsList(i18n, store) {
  const tempList = store.state.settingManagement.scheduleSettingsList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('SettingManagement').ScheduleSettings.executeExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '.executeBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.execute,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },

      {
        element: '.editBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.edit,
          description: i18n.$t('SettingManagement').ScheduleSettings.editExplain,
        },
      },

      {
        element: '.userBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.user,
          description: i18n.$t('SettingManagement').ScheduleSettings.userExplain,
        },
      },

      {
        element: '.groupBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.group,
          description: i18n.$t('SettingManagement').ScheduleSettings.groupExplain,
        },
      },

      {
        element: '.noticeObjectBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.noticeObject,
          description: i18n.$t('SettingManagement').ScheduleSettings.noticeObjectExplain,
        },
      },

      {
        element: '.deleteBtn',
        popover: {
          title: i18n.$t('SettingManagement').ScheduleSettings.delete,
          description: i18n.$t('SettingManagement').ScheduleSettings.deleteExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫製程能力規則
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpProcessAnalysisRule(i18n, store) {
  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#searchBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.filter,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.filterExplain,
        },
      },
      {
        element: '#createBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.createExplain,
          onNextClick: () => {
            if (store.state.settingManagement.scheduleSettingsFormVisible === true) {
              driverObj.moveNext();
            } else {
              driverObj.destroy();

              ElMessage({
                showClose: true,
                message: i18n.$t('DriverTourHelp').ClickAddButtonFirst,
                type: 'error',
                duration: 3000,
              });

              setTimeout(() => {
                driverObj.drive();
                driverObj.moveNext();
              }, 3000);
            }
          },
        },
      },
      {
        element: '#createForm',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.createExplainMore,
        },
      },
      {
        element: '#inputName',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('DriverTourHelp').ColumnIsRequire,
        },
      },
      {
        element: '#controlItem',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.selectMultipleControlItem,
        },
      },
      {
        element: '#statisticalCycle',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.statisticalCycle,
        },
      },
      {
        element: '#selectMultipleRule',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.create,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.selectMultipleRule,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });

  driverObj.drive();
}

/**
 * 呼叫製程能力規則-編輯與刪除
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpProcessAnalysisRuleEditAndDelete(i18n, store) {
  const tempList = store.state.settingManagement.processAnalysisRuleList;

  let message = '';
  if (tempList.length > 0) {
    message = i18n.$t('SettingManagement').ProcessAnalysisRule.editExplain;
  } else {
    message = i18n.$t('DriverTourHelp').createDataFirst;
  }

  const driverObj = driver({
    showProgress: true,
    steps: [
      {
        element: '#editBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.edit,
          description: message,
          onPopoverRender: () => {
            if (tempList.length === 0) {
              const nextBtn = document.querySelector('.driver-popover-next-btn');
              if (nextBtn) {
                console.log('nextBtn', nextBtn);
                nextBtn.setAttribute('disabled', 'true');
                nextBtn.setAttribute('style', 'color:#D0D0D0;cursor: default');
                nextBtn.classList.add('disabled'); // 可加上樣式
              }
            }
          },
        },
      },
      {
        element: '#deleteBtn',
        popover: {
          title: i18n.$t('SettingManagement').ProcessAnalysisRule.delete,
          description: i18n.$t('SettingManagement').ProcessAnalysisRule.deleteExplain,
        },
      },
    ],
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
  });
  driverObj.drive();
}
